import React from 'react'
import fieldTypes from '../data/fieldTypes.json'

function classNamesForField(field, printVersion) {
  const meta = fieldTypes[field.type]

  if(printVersion) {
    // return `field-instance print-version`
    return meta.shadow ? `field-instance print-version` : `field-instance print-version border-0`
  }

  return meta.shadow ? `field-instance shadow-sm` : `field-instance border-0`
}

const FieldShadowEffect = ({ field, printVersion, children }) => {
  const classNames = classNamesForField(field, printVersion)

  return (
    <div className={classNames}>
    { children }
    </div>
  )
}

export default FieldShadowEffect
